export default __webpack_public_path__ + "static/media/animation.7b72ce96.jpg";